export default __webpack_public_path__ + "static/media/Gauntlets of the Black Warden.5dad502f.jpg";